function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#F3BA2F"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.4087 28.7477L16.8173 25.339L13.4087 21.9303L10 25.339L13.4087 28.7477Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.2693 28.7477L40.6779 25.339L37.2693 21.9303L33.8606 25.339L37.2693 28.7477Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.3391 28.7477L28.7477 25.339L25.3391 21.9303L21.9304 25.339L25.3391 28.7477Z",
  fill: "white"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.0434 11.7043L25.339 10L15.9652 19.3738L19.3739 22.7825L25.339 16.8173L31.3042 22.7825L34.7129 19.3738L27.0434 11.7043Z",
  fill: "white"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.6346 38.9737L25.3389 40.678L34.7128 31.3042L31.3041 27.8955L25.3389 33.8607L19.3738 27.8955L15.9651 31.3042L23.6346 38.9737Z",
  fill: "white"
});

var SvgSourceBinance = function SvgSourceBinance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSourceBinance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source_binance.38fe85c5.svg";
export { ForwardRef as ReactComponent };